<template>
  <div id="center">
    <div id="north">
      <header-info cur="4"></header-info>
    </div>
    <div
      id="content"
      class="content"
    >
      <div class="detail-top hidebox">
        <div class="now">当前位置 ：
          <a href="/">首页</a>&gt;
          <a :href="'/www/more?category=' + $route.query.category">资讯列表</a>&gt;
          <a href="javascript:;">资讯详情</a>
        </div>
      </div>
      <div
        class="center_content"
        style="min-height:683px"
      >

        <div id="elList">
          <div class="news">
            <div class="title">{{infoData.title}}</div>

            <div class="info">
              <span
                class=""
                time=""
              >{{dict_info_source[infoData.source]}}</span>
              <span
                class=""
                time=""
              >{{infoData.publishDate}}</span>
              <span>
                <i class="iconfont">&#xe668;</i>
                {{infoData.view_count}}
              </span>
            </div>
            <div
              class="article"
              v-html="infoData.contents"
            ></div>
            <div
              class="file hidebox"
              v-if="infoData.filePath?infoData.filePath.length:''"
            >
              <div class="tips">
                <i class="iconfont">&#xe601;</i>
                <span>附件下载</span>
              </div>
              <div
                v-for="(item,index) in infoData.filePath"
                :key="index"
                class="link"
              >
                <a
                  :href="item.path"
                  :download="item.name"
                  @click="downloadCount"
                >{{item.name}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="south">
      <footer-info></footer-info>
      <div id="footer"></div>
    </div>
  </div>
</template>

<script>
import HeaderInfo from '../../../components/HeaderInfo'
import FooterInfo from '../../../components/FooterInfo'
export default {
  // 可用组件的哈希表
  components: { HeaderInfo, FooterInfo },
  // 接收传值
  props: {},
  // 数据对象
  data () {
    return {
      infoData: {
        created: ''
      }
    }
  },
  // 事件处理器
  methods: {
    async downloadCount() {
      await this.$http.post('/info_download_count/', {
        id: this.$route.query.id
      }).then((data) => {
      }).catch((error) => {
        console.log(error)
      })
    },
    // 编辑时查询
    async querySingle(id) {
      const url = '/allowany/info/' + id + '/'
      await this.$http.get(url).then((data) => {
        data.filePath = data.filePath ? JSON.parse(data.filePath) : []
        this.infoData = data
        document.title = this.infoData.title + ''
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('数据获取失败！')
      })
    },
    async viewCount(id) {
      await this.$http.post('/info_view_count/', {
        id: id
      }).then((data) => {
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  // 生命周期-实例创建完成后调用
  created () {
    window.scroll(0, 0)
    this.querySingle(this.$route.query.id)
    this.viewCount(this.$route.query.id)
  },
  // 生命周期-实例挂载后调用
  mounted () {

  },
  // 计算属性监听
  computed: {
    dict_info_source() {
      return this.$store.state.dict_info_source
    }
  }

}
</script>

<style lang="less" scoped>
body {
  background: #f4f4f4;
}
.center_content {
  margin: 20px auto;
  width: 1200px;
}
.center_content .now {
  color: #959595;
}
.center_content .now a {
  color: #959595;
  margin: 0 5px;
}
.center_content .news {
  padding: 20px 0;
}
.center_content .news .title {
  text-align: center;
  font-size: 26px;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #efefef;
}
.center_content .news .title .logo {
  max-width: 400px;
}
.center_content .news .info {
  text-align: center;
  color: #959595;
  margin-bottom: 20px;
  span {
    margin-right: 20px;
    i {
      color: #333;
      font-size: 14px;
    }
  }
}
.center_content .news .info span.source {
  margin-right: 10px;
}
.center_content .news .article {
  margin: 20px 0;
  line-height: 2em;
  color: #444;
  font-size: 16px;
  word-break: break-all;
  min-height: 400px;
}
.center_content .news .article a {
  color: #2e82ff;
}
.center_content .news .article p {
  text-indent: 2em;
  margin-bottom: 10px;
}
.center_content .news .article img {
  max-width: 100%;
  text-align: center;
  margin: 10px 0;
}
@media screen and (max-width: 1000px) {
  body {
    min-width: 0;
  }
  .detail-top .now {
    width: auto !important;
  }
  #app #center {
    padding-bottom: 0 !important;
  }
  .header_container {
    width: auto;
  }
  .header_container .nav {
    display: none;
  }
  .header_container .logo {
    left: 20px;
    position: absolute;
  }
  #content {
    padding: 0 10px;
  }
  .center_content {
    width: auto;
    border-radius: 10px;
    padding: 10px;
    margin: 0;
  }
  .center_content .news .article img {
    height: auto !important;
  }
  .bottom {
    line-height: 24px;
  }
  .center_content .now {
    display: none;
  }
  .center_content .news .article p {
    text-indent: 0;
  }
}
.detail-top {
  width: 100%;
  height: 80px;
  background: url(../../../assets/images/bg.jpg) no-repeat;
  background-size: 100% auto;
  background-position: center;
  .now {
    width: 1200px;
    line-height: 80px;
    margin: 0 auto;
    a {
      color: #333;
    }
  }
}
.file {
  width: 1200px;
  height: 115px;
  padding: 20px 40px;
  box-sizing: border-box;
  background: #f1f4fb;
  border: 1px solid #d5dbe9;
  .tips {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
    i {
      margin-right: 10px;
    }
  }
  .link {
    color: rgb(0, 89, 255);
    text-decoration: underline;
  }
}
</style>
